export const EMPTY = 0;
export const PLAYER_1 = 1;
export const PLAYER_2 = 2;
export const PLAYER_3 = 3;
export const VALID_MOVE = 10;

export const BOARD_SIZE = 10;
export const WIN_LENGTH = 5;
export const PIECES_PER_PLAYER = 5;
export const TOTAL_PLACEMENTS = PIECES_PER_PLAYER * 3;

export const PHASE_PLACEMENT = 1;
export const PHASE_MOVEMENT = 2;
export const PHASE_GAME_OVER = 3;

export const PLAYER_NAMES = ["blue", "green", "red"];
export const PLAYER_COLORS = ["#7FDBFF", "#2ECC40", "#FF4136"];
export const PLAYER_PIECES = ["circle.svg", "square.svg", "triangle.svg"];
